import { useCallback, useState } from "react";

import { userService } from "@/config/services";

import { UpdateUserProfileParams, UserProfile } from "../UserService.types";
import useProfileData from "./useProfileData";
import { sanitizeProfileData } from "../UserService.utils";

function useUpdateProfile() {
  const { profileData, isProfileDataLoading } = useProfileData();
  const [isUpdating, setIsUpdating] = useState(false);

  const update = useCallback(
    (profileData: UserProfile, params?: UpdateUserProfileParams) => {
      if (isUpdating) {
        return Promise.reject();
      }

      setIsUpdating(true);

      return userService
        .updateUserInfo(
          {
            details: JSON.stringify(sanitizeProfileData(profileData)),
          },
          params
        )
        .finally(() => {
          setIsUpdating(false);
        });
    },
    [isUpdating]
  );

  return {
    profileData,
    isProfileDataLoading,
    update,
    isUpdating,
  };
}

export default useUpdateProfile;
